// CSS styles
export const styles = {
  app: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    color: '#1e293b'
  },
  header: {
    backgroundColor: 'white',
    borderBottom: '1px solid #e2e8f0',
    position: 'sticky',
    top: 0,
    zIndex: 50,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px 20px',
    textAlign: 'center'
  },
   title: {
    fontSize: '28px',         // match Budget Manager
    fontWeight: '700',
    color: '#1f2937',         // slightly darker gray
    marginBottom: '24px',
    letterSpacing: '-0.025em'
  },
  nav: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '12px'
  },
  navButton: {
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '500',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: '120px',
    justifyContent: 'center'
  },
  navButtonActive: {
    backgroundColor: '#3b82f6',
    color: 'white'
  },
  navButtonInactive: {
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    border: '1px solid #e2e8f0'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 20px'
  },
  welcomeCard: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    padding: '32px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
  },
  welcomeTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: '16px'
  },
  welcomeText: {
    color: '#64748b',
    marginBottom: '32px',
    lineHeight: '1.6',
    fontSize: '16px'
  },
  toolGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
    marginTop: '32px'
  },
  toolCard: {
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textAlign: 'center'
  },
  toolIcon: {
    fontSize: '32px',
    marginBottom: '12px',
    display: 'block'
  },
  toolName: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#1e293b',
    marginBottom: '4px'
  },
  toolDescription: {
    fontSize: '12px',
    color: '#64748b',
    lineHeight: '1.4'
  },
  // Todo List Styles
  todoContainer: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '24px',
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
  },
  todoHeader: {
    marginBottom: '24px'
  },
  todoTitle: {
    fontSize: '28px',         // match Budget Manager
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: '16px'
  },
  stats: {
    display: 'flex',
    gap: '16px',
    fontSize: '14px',
    color: '#64748b'
  },
  addTaskSection: {
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px'
  },
  addTaskForm: {
    display: 'flex',
    gap: '8px',
    marginBottom: '12px'
  },
  input: {
    flex: 1,
    padding: '10px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '14px',
    backgroundColor: 'white',
    outline: 'none'
  },
  select: {
    padding: '10px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '14px',
    backgroundColor: 'white',
    outline: 'none'
  },
  addButton: {
    padding: '10px 16px',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'background-color 0.2s'
  },
  filterSection: {
    marginBottom: '16px',
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  filterButton: {
    padding: '6px 12px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '500',
    transition: 'all 0.2s'
  },
  filterActive: {
    backgroundColor: '#3b82f6',
    color: 'white'
  },
  filterInactive: {
    backgroundColor: '#f1f5f9',
    color: '#64748b'
  },
  taskList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  taskItem: {
    padding: '12px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    transition: 'all 0.2s',
    backgroundColor: 'white'
  },
  taskItemCompleted: {
    backgroundColor: '#f0fdf4',
    borderColor: '#bbf7d0'
  },
  taskContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    border: '2px solid #d1d5db',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  checkboxCompleted: {
    backgroundColor: '#10b981',
    borderColor: '#10b981',
    color: 'white'
  },
  taskText: {
    flex: 1,
    fontSize: '15px',
    color: '#1e293b'
  },
  taskTextCompleted: {
    textDecoration: 'line-through',
    color: '#64748b'
  },
  taskMeta: {
    fontSize: '12px',
    color: '#64748b',
    marginTop: '4px'
  },
  deleteButton: {
    padding: '6px',
    color: '#ef4444',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '4px',
    transition: 'background-color 0.2s'
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#64748b'
  },
  progressSection: {
    marginTop: '24px',
    paddingTop: '16px',
    borderTop: '1px solid #e2e8f0'
  },
  progressContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    color: '#64748b'
  },
  progressBar: {
    width: '128px',
    height: '8px',
    backgroundColor: '#e2e8f0',
    borderRadius: '4px',
    overflow: 'hidden'
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#10b981',
    transition: 'width 0.3s ease'
  }
};